import React from "react";
import {
  Card,
  CloseButton,
  Flex,
  Stack,
  Text,
} from "@chakra-ui/react";

interface AuthCardProps extends React.PropsWithChildren {
  title?: string;
  onClose?: () => void;
}

const AuthCard = ({ title, children, onClose }: AuthCardProps) => {
  return (
    <Card.Root maxW="md" w="430px" mx="auto" borderRadius={35} variant='elevated'>
      <Card.Body px="9" py="5">
        <Stack gap="3">
          {title &&
            <Flex justify={'space-between'} alignItems="center">
              <Text fontSize="18px" fontWeight={'semibold'}>{title}</Text>
              <CloseButton size="lg" onClick={() => onClose?.()}/>
            </Flex>
          }
          {children}
        </Stack>
      </Card.Body>
    </Card.Root>
  );
};

export default AuthCard;